var map = {
	"./11.jpg": 885,
	"./12.jpg": 297,
	"./123.jpg": 759,
	"./13.jpg": 392,
	"./14.jpg": 206,
	"./36_plant_sapplings_was_donated_to_government_school_chennai.jpg": 26,
	"./88.jpg": 925,
	"./A_mega_awarness_program_about_women_harrasement.jpg": 242,
	"./WhatsApp Image 2023-02-26 at 18.31.48.jpg": 69,
	"./WhatsApp Image 2023-02-26 at 18.44.10.jpg": 218,
	"./a.jpg": 58,
	"./a_awarenesss_program_to_girl_students_about_menstrual_cycle_and_women_harrasement.jpg": 73,
	"./a_visit_to_backward_slum.jpg": 444,
	"./a_visit_to_children's_orphanage.jpg": 65,
	"./a_visit_to_mentally_challenged_school.jpg": 888,
	"./bb.jpg": 881,
	"./celebrated_our_1st_year_anniversary_at_children's_orphanage.jpg": 965,
	"./celebrating_diwali_with_homeless_roadside_people.jpg": 717,
	"./celebrating_new_year_at_children's_orphanage.jpg": 335,
	"./collected_and_donated_20_books_to_state_prison_department.jpg": 856,
	"./d.jpg": 333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95;